import { render, staticRenderFns } from "./sensitive.vue?vue&type=template&id=35c620d0&scoped=true&"
import script from "./sensitive.vue?vue&type=script&lang=ts&"
export * from "./sensitive.vue?vue&type=script&lang=ts&"
import style0 from "./sensitive.vue?vue&type=style&index=0&id=35c620d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c620d0",
  null
  
)

export default component.exports